export const calendarGoogleEvents = {
    GET_GOOGLE_EVENTS_OF_CALENDAR: "GET_GOOGLE_EVENTS_OF_CALENDAR",
    GET_GOOGLE_EVENTS_OF_CALENDAR_SUCCESS : "GET_GOOGLE_EVENTS_OF_CALENDAR_SUCCESS",
    GET_GOOGLE_EVENTS_OF_CALENDAR_NULL : "GET_GOOGLE_EVENTS_OF_CALENDAR_NULL",
    GET_GOOGLE_EVENTS_OF_CALENDAR_ERROR : "GET_GOOGLE_EVENTS_OF_CALENDAR_ERROR",
    CLEAR_FILTERS: "CLEAR_FILTERS",
    CLEAR_CALENDAR_GOOGLE_EVENTS_LIST: "CLEAR_CALENDAR_GOOGLE_EVENTS_LIST"
}